/** Short words that are English, not acronyms: "IN_TRANSIT" reads "In transit", "SERVICER_VS_BANK" "Servicer vs bank" (F-LR-055). */
const SMALL_WORDS = new Set(['NEW', 'NOT', 'YES', 'NO', 'MAX', 'MIN', 'DUE', 'IN', 'BY', 'VS', 'OF', 'TO', 'ON', 'AT', 'OR', 'AND',
  'THE', 'FOR', 'PER', 'A', 'AN', 'AS', 'IS', 'UP', 'OFF', 'OUT', 'ALL', 'ANY', 'NET', 'PAY', 'RUN', 'SET', 'END', 'DAY', 'BUT', 'FEE']);
export function words(value: unknown): string {
  if(value === null || value === undefined || value === '') return '—';
  const text = String(value);
  if(!/^[A-Z0-9_ ]+$/.test(text)) return text;
  return text.split(/[_ ]+/).map((word, i) => word.length <= 3 && !SMALL_WORDS.has(word) ? word
    : i === 0 ? word.charAt(0) + word.slice(1).toLowerCase() : word.toLowerCase()).join(' ');
}
